import React, { Component } from 'react';
import Navigation from '../Navigation/Navigation';
import Profile from '../Profile/Profile';
import Listview from '../Listview/Listview';
import SearchResults from '../Search/SearchResult/SearchResult';
import ProductDetail from '../Detailview/ProductDetail/ProductDetail';
import Info from '../Info/Info';
import './Content.css';
import Searchbox from "../Search/Searchbox/Searchbox";
import PDF from '../Detailview/PDF/PDF';

class Content extends Component {
    render() {
        this.props.createHistoryEntry();
        if(this.props.route === 'search') {
            return <div>
                <Searchbox resetSearch={this.props.resetSearch} hash={this.props.hash}
                           route={this.props.route} changeRoute={this.props.changeRoute}
                           lastSearchword={this.props.lastSearchword} setLastsearch={this.props.setLastsearch}
                           results={this.props.results} setResults={this.props.setResults}
                           searchword={this.props.searchword} setSearchword={this.props.setSearchword} />
                    <SearchResults setProduct={this.props.setProduct} results={this.props.results} changeRoute={this.props.changeRoute} setFile={this.props.setFile} hash={this.props.hash} height={this.props.height} width={this.props.width} />
                </div>
        }else if(this.props.route === 'product') {
            return <div>
                <ProductDetail height={this.props.height} width={this.props.width} product={this.props.product} hash={this.props.hash} changeRoute={this.props.changeRoute} setFile={this.props.setFile} />
            </div>
        }else if(this.props.route === 'list') {
            return <div>
                <Listview category={this.props.category} height={this.props.height} width={this.props.width} product={this.props.product} setProduct={this.props.setProduct} changeRoute={this.props.changeRoute}  hash={this.props.hash} setFile={this.props.setFile} />
            </div>
        }else if(this.props.route === 'profile') {
            return <div>
                <Profile category={this.props.category} product={this.props.product} setProduct={this.props.setProduct} changeRoute={this.props.changeRoute}  hash={this.props.hash} logoutUser={this.props.logoutUser} />
            </div>
        }else if(this.props.route === 'PDF'){
           return <div>
                   <PDF file={this.props.file} changeRoute={this.props.changeRoute} route={this.props.route} />
               </div>
        }else if(this.props.route === 'info'){
            return <div>
                <Info hash={this.props.hash} />
            </div>
        }else{
            return <div>
                <Searchbox resetSearch={this.props.resetSearch} hash={this.props.hash}
                           route={this.props.route} changeRoute={this.props.changeRoute}
                           lastSearchword={this.props.lastSearchword} setLastsearch={this.props.setLastsearch}
                           results={this.props.results} setResults={this.props.setResults}
                           searchword={this.props.searchword} setSearchword={this.props.setSearchword} />
                <Navigation route={this.props.route} rootCategory={this.props.rootCategory} setRootCategory={this.props.setRootCategory} globalCategory={this.props.category} changeRoute={this.props.changeRoute} setCategory={this.props.setCategory} hash={this.props.hash} />
            </div>
        }
    }
}

export default Content;


// WEBPACK FOOTER //
// ./src/Components/Content/Content.js